import axios from 'axios/index'
import packages from '../../components/json/packages.json'

const namespaced = true

const state = {
  packages: null,
  packageHistory: null,
  operationCodes: null,
  xmlDocument: null,
  ftsHistory: null,
  customsMessages: null,
  documentProperties: null,
  packageProperties: null,
  ppdDocument: null,
  arrOfIcons: {
    zip: 'fas fa-file-archive',
    '7z': 'fas fa-file-archive',
    rar: 'fas fa-file-archive',
    pdf: 'fas fa-file-pdf',
    tif: 'fas fa-file-image',
    txt: 'fas fa-file-alt',
    rtf: 'fas fa-file-alt',
    doc: 'fas fa-file-word',
    docx: 'fas fa-file-word',
    jpg: 'fas fa-file-image',
    jpeg: 'fas fa-file-image',
    png: 'fas fa-file-image',
    gif: 'fas fa-file-image',
    xls: 'fas fa-file-excel',
    xlsx: 'fas fa-file-excel',
    csv: 'fas fa-file-csv',
    js: 'fas fa-file-code',
    css: 'fas fa-file-code',
    html: 'fas fa-file-code',
    xml: 'fas fa-file-code',
    xsl: 'fas fa-file-code',
    xslt: 'fas fa-file-code',
    ppt: 'fas fa-file-powerpoint',
    pptx: 'fas fa-file-powerpoint',
    pps: 'fas fa-file-powerpoint'
  },
  selectVal: {
    current_status: undefined
  },
  documents: null,
  files: null
}

const actions = {
  loadPackages ({ commit, state }, payload) {
    /* let url = '/api/private/v3.0/packages/'
    if (payload) {
      url += '?'
      if (payload.status && payload.status.length) {
        for (let i = 0; i < payload.status.length; i++) {
          i === payload.status.length - 1 ? url += 'status[]=' + payload.status[i] : url += 'status[]=' + payload.status[i] + '&'
        }
      }
      if (payload.datetime_start && payload.datetime_start.length) {
        (!payload.status.length)
          ? (url += 'datetime_start=' + payload.datetime_start)
          : (url += '&datetime_start=' + payload.datetime_start)
      }
      if (payload.datetime_end && payload.datetime_end.length) {
        (!payload.status && !payload.datetime_start)
          ? (url += 'datetime_end=' + payload.datetime_end)
          : (url += '&datetime_end=' + payload.datetime_end)
      }
      if (payload.query) {
        (!payload.status.length && !payload.datetime_start.length && !payload.datetime_end.length)
          ? (url += 'query=' + payload.query)
          : (url += '&query=' + payload.query)
      }
    }
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => response.data)
        .then(packages => {
          commit('parsePackages', packages)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    }) */
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('parsePackages', packages)
        resolve('result')
      }, 1000)
    })
  },
  loadOperationCodes ({ commit, state }) {
    axios.get('/api/private/v3.0/list/package/operations/')
      .then(response => response.data)
      .then(codes => {
        commit('parseOperationCodes', codes)
      })
      .catch(error => {
        console.log(error)
      })
  },
  loadDocumentProperties ({ commit, state }) {
    axios.get('/api/private/v3.0/list/package/document/properties/')
      .then(response => response.data)
      .then(properties => {
        commit('parseDocumentProperties', properties)
      })
      .catch(error => {
        console.log(error)
      })
  },
  loadPackageProperties ({ commit, state }) {
    axios.get('/api/private/v3.0/list/package/document/properties/groups/')
      .then(response => response.data)
      .then(properties => {
        commit('parsePackageProperties', properties)
      })
      .catch(error => {
        console.log(error)
      })
  },
  loadCustomsMessages ({ commit, state }) {
    axios.get('/api/private/v3.0/list/customs/messages/')
      .then(response => response.data)
      .then(messages => {
        commit('parseCustomsMessages', messages)
      })
      .catch(error => {
        console.log(error)
      })
  },
  loadPackageDocuments ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/private/v3.0/packages/' + payload + '/documents/')
        .then(response => response.data)
        .then(documents => {
          commit('parsePackageDocuments', { documents: documents, id: payload })
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadPackageFiles ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/private/v3.0/packages/' + payload + '/files/')
        .then(response => response.data)
        .then(files => {
          commit('parsePackageFiles', { files: files, id: payload })
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadXml ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/private/v3.0/packages/' + payload.pkgId + '/documents/' + payload.documentId + '/content/')
        .then(response => response.data)
        .then(xml => {
          commit('showXml', xml)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadPPDForms ({ commit, state }, payload) {
    axios.get('/api/private/v3.0/packages/' + payload.pkgId + '/documents/' + payload.documentId + '/ppd/')
      .then(response => response.data)
      .then(ppd => {
        commit('showPPD', ppd)
      })
      .catch(error => {
        console.log(error)
      })
  },
  loadPackageHistory ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/private/v3.0/packages/' + payload + '/history/')
        .then(response => response.data)
        .then(history => {
          commit('parsePackageHistory', history)
          resolve('result')
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  loadFtsExchangeHistory ({ commit, state }, payload) {
    axios.get('/api/private/v3.0/packages/' + payload + '/messages/')
      .then(response => response.data)
      .then(history => {
        commit('parseFtsExchangeHistory', history)
      })
      .catch(error => {
        console.log(error)
      })
  },
  sendEmail ({ commit, state }, payload) {
    axios.post('/api/private/v3.0/packages/' + payload.packageId + '/documents/' + payload.documentId + '/pdf/email/')
      .then(response => {
        this._vm.$bvToast.toast('Документ отправлен на ваш e-mail', {
          variant: 'success',
          toaster: 'b-toaster-top-right'
        })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

const mutations = {
  parsePackages (state, value) {
    for (let i = 0; i < value.length; i++) {
      value[i].showDocuments = false
      value[i].documents = null
      value[i].hasDocuments = false
      value[i].files = null
      value[i].actions = { visible: false }
      value[i].index = i.toString()
      value[i].highlight = false
      for (const item in value[i]) {
        if (item === 'info') {
          for (const j in value[i][item]) {
            value[i][j] = convertArrToString(value[i][item][j])
          }
        }
      }
    }

    function convertArrToString (val) {
      let str = ''
      for (let i = 0; i < val.length; i++) {
        (i === val.length - 1) ? (str += val[i]) : (str += val[i] + ', ')
      }
      return str
    }

    state.packages = value
  },
  parsePackageHistory (state, value) {
    state.packageHistory = value
  },
  parseDocumentProperties (state, value) {
    state.documentProperties = value
  },
  parsePackageProperties (state, value) {
    state.packageProperties = value
  },
  parsePackageDocuments (state, value) {
    for (let j = 0; j < value.documents.length; j++) {
      if (value.documents[j].visible === true) {
        value.documents[j].hasDocuments = true
      }
    }
    state.documents = value
  },
  parsePackageFiles (state, value) {
    state.files = value
  },
  changeActionsVisibility (state, value) {
    for (let i = 0; i < state.packages.length; i++) {
      if (state.packages[i].id === value.id) {
        state.packages[i].actions.visible = !state.packages[i].actions.visible
      }
    }
  },
  changeAttachmentsVisibility (state, value) {
    for (let i = 0; i < state.packages.length; i++) {
      if (state.packages[i].id === value) {
        state.packages[i].showDocuments = !state.packages[i].showDocuments
      }
    }
  },
  parseOperationCodes (state, value) {
    state.operationCodes = value
  },
  parseCustomsMessages (state, value) {
    state.customsMessages = value
  },
  showXml (state, value) {
    state.xmlDocument = value
  },
  showPPD (state, value) {
    state.ppdDocument = value
  },
  updatePPD (state, value) {
    state.ppdDocument = value
  },
  updateFtsHistory (state, value) {
    state.ftsHistory = value
  },
  parseFtsExchangeHistory (state, value) {
    const tree = []
    let parents = []
    parents = value.filter(prop => prop.initial_envelope_id === null)
    for (let j = 0; j < parents.length; j++) {
      const parent = parents[j]
      const dataTraverse = function (parent) {
        parent.children = []
        value.forEach(function (item, i, arr) {
          if (item.initial_envelope_id === parent.envelope_id) {
            parent.children.push(item)
            parent.children.sort(function (prev, next) {
              const dateA = new Date(prev.preparation_datetime)
              const dateB = new Date(next.preparation_datetime)
              if (dateA - dateB === 0) {
                const cmnA = prev.code.toLowerCase()
                const cmnB = next.code.toLowerCase()
                if (cmnA < cmnB) return -1
                if (cmnA > cmnB) return 1
                return 0
              }
              return dateA - dateB
            })
            dataTraverse(item)
          } else {
            return parent
          }
        })
        return parent
      }
      const ftsMessages = dataTraverse(parent)
      tree.push(ftsMessages)
    }
    state.ftsHistory = tree
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
